import React from 'react';
import { KpeLayout } from '../../../_shared/components/KpeLayout/KpeLayout';
import { useKpeSelector } from '../../../_shared/store/store';
import { FactsHeader } from '../../components/FactsHeader/FactsHeader';
import { EmployeeFactsView } from '../../views/EmployeeFacts/EmployeeFactsView';
import { ManagerFactsView } from '../../views/ManagerFacts/ManagerFactsView';
import { EstimateFactsView } from '../../views/EstimateFacts/EstimateFactsView';
import { HrApprovalFacts } from '../../views/HrApprovalFacts/HrApprovalFacts';
import styles from './FactsPage.module.scss';

function FactsContent() {
  const role = useKpeSelector((s) => s.kpe.role);

  return (
    <div className={styles.page}>
      <FactsHeader
        year={2027}
        status="Ввод фактических значений"
        lastUpdate="12.01.2027"
        factDeadline="до 20 января"
        appealDeadline="до 31 января"
        premiumDeadline="до 15 марта"
      />
      {role === 'Р' && <EmployeeFactsView />}
      {role === 'ВР' && <ManagerFactsView />}
      {role === 'АС' && <HrApprovalFacts />}
      {role === 'OC' && <EstimateFactsView />}
    </div>
  );
}

export function FactsPage() {
  return (
    <KpeLayout>
      <FactsContent />
    </KpeLayout>
  );
}
